import { weeklyPicks } from "@/mocks/site";
import { Reveal, SectionHead } from "./ui";

const trendIcon: Record<string, string> = {
  up: "ri-arrow-up-line",
  steady: "ri-subtract-line",
  down: "ri-arrow-down-line",
};
const trendTone: Record<string, string> = {
  up: "text-primary-600 bg-primary-50",
  steady: "text-secondary-500 bg-secondary-100",
  down: "text-accent-700 bg-accent-100",
};

export default function Ranking() {
  return (
    <section id="ranking" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-3">
          {/* Left intro */}
          <Reveal className="lg:col-span-1">
            <div className="flex h-full flex-col rounded-2xl bg-secondary-100/60 p-6 ring-1 ring-background-200 md:p-7">
              <span className="font-label text-xs font-semibold uppercase tracking-[0.25em] text-secondary-600">
                Weekly Picks
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-[28px]">
                本周吃瓜热榜
              </h2>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                编辑部按读者追更热度、事件影响与反转含金量，盘点了这一周最值得回看的高能事件。旧瓜回访，也常有新料。
              </p>
              <ul className="mt-5 flex flex-col gap-2.5 text-sm text-foreground-700">
                <li className="flex items-start gap-2.5">
                  <i className="ri-arrow-up-line mt-0.5 text-primary-600" aria-hidden="true"></i>
                  <span>热度上升：讨论量与转发量同步攀升</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-subtract-line mt-0.5 text-secondary-500" aria-hidden="true"></i>
                  <span>持续关注：处于等待回应的窗口期</span>
                </li>
                <li className="flex items-start gap-2.5">
                  <i className="ri-arrow-down-line mt-0.5 text-accent-700" aria-hidden="true"></i>
                  <span>热度回落：事件已阶段性收尾</span>
                </li>
              </ul>
              <div className="mt-auto pt-6">
                <a
                  href="#about"
                  className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2.5 text-sm font-semibold text-foreground-950 ring-1 ring-background-200 transition-colors hover:bg-secondary-200"
                >
                  查看更多盘点
                  <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </a>
              </div>
            </div>
          </Reveal>

          {/* Right ranking list */}
          <Reveal delay={120} className="lg:col-span-2">
            <ol className="flex h-full flex-col divide-y divide-background-200 rounded-2xl border border-background-200 bg-background-100/50">
              {weeklyPicks.map((p) => (
                <li key={p.id}>
                  <a
                    href="#tracking"
                    className="group flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-50 md:gap-6 md:px-6"
                  >
                    <span className="w-8 shrink-0 font-heading text-3xl font-black leading-none text-foreground-950/85 md:w-10 md:text-4xl">
                      {p.rank}
                    </span>
                    <span className="min-w-0 flex-1">
                      <span className="block truncate text-sm font-semibold text-foreground-800 transition-colors group-hover:text-primary-700 md:text-base">
                        {p.title}
                      </span>
                      <span className="mt-1 block text-xs text-secondary-500">{p.views}</span>
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm ${trendTone[p.trend]}`}
                      title={
                        p.trend === "up"
                          ? "热度上升"
                          : p.trend === "steady"
                          ? "持续关注"
                          : "热度回落"
                      }
                    >
                      <i className={trendIcon[p.trend]} aria-hidden="true"></i>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </Reveal>
        </div>
      </div>
    </section>
  );
}